import { api } from "@/lib/api";

export const MAC_APPS = [
  ["futzap_antigo", "Futzap ANTIGO"], ["futzap_novo", "Futzap NOVO"], ["futmob1", "Futmob 1"],
  ["futmob2", "Futmob 2"], ["futmobplus", "Futmob Plus"], ["pipoca", "Pipoca"], ["weplay_plus", "Weplay PLUS"],
];

// server-side lookup through the residential proxy; returns matches grouped by app
export const searchMac = async (mac, app = null) => {
  const { data } = await api.post("/macs/search", { mac, app });
  const byApp = {};
  for (const m of data.matches) (byApp[m.app] = byApp[m.app] || []).push(m);
  return { matches: data.matches, byApp, errors: data.errors };
};
